<template>
    <div>
        <div class="pro-table">
            <div class="row">
                <div class="col-md-3">
                    <div class="pro-filter">
                        <div class="clar-btn">
                        <a @click="getData()" class="btn btn-link btn-primary-with-gradient btn-lg">Clear
                        </a>
                        </div>
                        <div id="accordion">
                            <div v-for="(value,name) in filters" class="card">
                                <div class="collape---btn">
                                <button class="btn btn-link" data-toggle="collapse"
                                        :data-target="'#'+name" aria-expanded="true"
                                >{{name | capitalize}}
                                </button>
                                <!-- <i class="fa fa-sort-down"></i> -->
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </div>
                                <div :id="name" class="collapse"
                                     aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body" id="pro-item">
                                        <a v-for="item in value" @click="filterAttr(name,item)">{{item}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 pl-0">
                    <div class="position-relative">
                        <div v-if="loader" class="content-loader">
                            <i class="fa fa-spinner fa-pulse fa-3x" aria-hidden="true"></i>
                        </div>
                        <vue-good-table :columns="columns" :rows="rows"
                                        :pagination-options="{ enabled: true, mode: 'records'}"
                                        styleClass="vgt-table bordered">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'product'">
                                    <span>
                                        <a :href="baseUrl+''+props.row.url">{{props.row.product}}</a>
                                    </span>
                                </span>
                                <span v-else-if="props.column.field == 'image'">
                                    <div class="pro--table--imge">
                                    <div :href="props.row.image" class="" style="position: relative;">
                                        <a :href="baseUrl+''+props.row.url"><img :src="props.row.image" class="zomm----img" :data-zoom-image="props.row.image" style="width:50px;height:50px;"></a>
                                    </div>
                                    </div>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {VueGoodTable} from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css'


    export default {
        components: {
            VueGoodTable
        },
        props: ['categoryId', 'productId'],
        data: function () {
            return {
                attributes: [],
                columns: [],
                rows: [],
                filters: [],
                loader: null,
            }
        },
        methods: {
            filterAttr(name, item) {
                var data = [];
                for (var i = 0; i < this.rows.length; i++) {
                    if (this.rows[i][name] == item) {
                        // console.log(this.rows[i]);
                        data.push(this.rows[i]);
                    }
                }
                this.rows = data;
            },


            getData() {
                let that = this;
                console.log(process.env.MIX_API_URL);
                this.loader = true;
                axios.get(process.env.MIX_API_URL + '/product-category/' + this.categoryId + '/' + this.productId)
                    .then(function (response) {
                        console.log(response.data);
                        that.columns = response.data.columns;
                        that.rows = response.data.rows;
                        that.filters = response.data.filters;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
        },
        mounted: function () {
            this.getData();
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                let url = window.location.href;
                var str = url.substr(url.lastIndexOf('/') + 1) + '$';
                return url.replace(new RegExp(str), '');
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                value = value.replace(/([A-Z])/g, ' $1').trim()
                return value
            }
        }
    }

</script>
